import { useEffect, useMemo, useRef, useState } from 'react';

import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { getActiveChannel } from '@/store/slices/user/selectors';
import { loadProjectGroups } from '@/store/slices/project';
import { selectProjectGroups } from '@/store/slices/project/selectors';

interface IUseFetchProjectGroupsProps {
  skip?: boolean;
}

const useFetchProjectGroups = (props?: IUseFetchProjectGroupsProps) => {
  const { skip } = props || {};

  const activeChannel = useAppSelector(getActiveChannel);
  const projectGroups = useAppSelector(selectProjectGroups);

  const [loading, setLoading] = useState(false);

  const hasProjectGroups = useMemo(() => projectGroups !== null, [projectGroups]);

  const fetching = useRef(false);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (fetching.current || !activeChannel || hasProjectGroups || skip) {
      return;
    }

    fetching.current = true;
    setLoading(true);

    const fetchGroups = async () => {
      try {
        await dispatch(loadProjectGroups(activeChannel));
      } catch (error) {
        console.error('Error fetching group filters:', error);
      } finally {
        fetching.current = false;
        setLoading(false);
      }
    };

    fetchGroups();
  }, [activeChannel, dispatch, hasProjectGroups, skip]);

  return { loading };
};

export default useFetchProjectGroups;
